module.exports = __webpack_public_path__ + "img/close.1d66018d.svg";